import React from 'react'
import { FaPlus } from 'react-icons/fa'
import { Btn, CustomDropdown, InputText, SectionTitle } from '../../../../components'
import * as colors from '../../../../assets/js/colors'
import AcoesLinha from './AcoesLinha'
import OpcoesResposta from './OpcoesResposta'
import { FIELD_TYPES, LIMITES } from './checklist.util'

const styles = {
  cabecalho: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  vazio: { color: colors.gray, fontSize: '0.8rem', marginTop: 10 },
  acoes: { display: 'flex', alignItems: 'flex-end', paddingBottom: 10 },
  opcoes: { borderLeft: `3px solid ${colors.azul}`, paddingLeft: 15, marginLeft: 8 },
}

const CampoLinha = React.memo(function CampoLinha({
  campo,
  secao,
  indice,
  primeiro,
  ultimo,
  autoFocus,
  localDispatch,
}) {
  const onChange = (chave, valor) => localDispatch.onCampoChange(secao, campo.id, chave, valor)

  return (
    <div className="p-grid">
      <div className="p-md-8 p-col-12">
        <InputText
          label={`Campo ${indice + 1} - Rótulo:*`}
          marginTop={10}
          maxLength={LIMITES.rotulo}
          autoFocus={autoFocus}
          value={campo.label}
          onChange={value => onChange('label', value)}
        />
      </div>
      <div className="p-md-3 p-col-12">
        <CustomDropdown
          label="Tipo de campo:*"
          marginTop={10}
          optionLabel="label"
          options={FIELD_TYPES}
          value={FIELD_TYPES.find(tipo => tipo.value === campo.field_type) || null}
          onChange={value => value && onChange('field_type', value.value)}
        />
      </div>
      <div className="p-md-1 p-col-12" style={styles.acoes}>
        <AcoesLinha
          primeiro={primeiro}
          ultimo={ultimo}
          onMover={direcao => localDispatch.onMoverCampo(secao, campo.id, direcao)}
          onRemover={() => localDispatch.onRemoverCampo(secao, campo.id)}
        />
      </div>
      {campo.options ? (
        <div className="p-col-12">
          <div style={styles.opcoes}>
            <OpcoesResposta
              opcoes={campo.options}
              comResultado={false}
              onChange={opcoes => onChange('options', opcoes)}
            />
          </div>
        </div>
      ) : null}
    </div>
  )
})

export default function CamposChecklist({ titulo, secao, campos, focoId, localDispatch }) {
  return (
    <div style={{ marginTop: 10 }}>
      <SectionTitle title={titulo} />
      <div style={styles.cabecalho}>
        <span style={styles.vazio}>
          {campos.length
            ? 'Estes campos aparecem em todas as páginas do relatório do checklist.'
            : 'Nenhum campo adicionado.'}
        </span>
        {campos.length < LIMITES.campos ? (
          <Btn onClick={() => localDispatch.onAdicionarCampo(secao)}>
            <FaPlus style={{ marginRight: 5 }} size={10} />
            Adicionar campo
          </Btn>
        ) : null}
      </div>
      {campos.map((campo, indice) => (
        <CampoLinha
          key={campo.id}
          campo={campo}
          secao={secao}
          indice={indice}
          primeiro={indice === 0}
          ultimo={indice === campos.length - 1}
          autoFocus={campo.id === focoId}
          localDispatch={localDispatch}
        />
      ))}
    </div>
  )
}
